import { Injectable } from '@angular/core';
import { Client, Message } from '@stomp/stompjs';
import * as SockJS from 'sockjs-client';
import { Subject } from 'rxjs';
import { AuthenticationService } from './authentication.service';
import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class WebsocketService {
    private stompClient!: Client;
    public notifications: Subject<string> = new Subject<string>();
    private baseurl: string = environment.baseUrl;
    constructor(private authService: AuthenticationService) { }

    async initializeWebSocketConnection() {
        console.log('Initializing WebSocket connection...');
        try {
            const ws = new SockJS(this.baseurl+"/ws");
            console.log('SockJS instance created.');

            const token = await this.authService.getToken();
            console.log('Token retrieved:', token);

            this.stompClient = new Client({
                webSocketFactory: () => ws,
                debug: function(str) {
                    console.log('STOMP debug:', str);
                },
                connectHeaders: {
                    Authorization: token
                },
                onConnect: async (frame) => {
                    console.log('Connected: ' + frame);

                    this.stompClient.subscribe('/user/queue/notifications', (message: Message) => {
                        if (message.body) {
                            console.log('Received message:', message.body);
                            this.notifications.next(message.body);
                        }
                    });
                },
                onStompError: (frame) => {
                    console.error('Broker reported error: ' + frame.headers['message']);
                    console.error('Additional details: ' + frame.body);
                }
            });

            console.log('Activating STOMP client...');
            this.stompClient.activate();
        } catch (error) {
            console.error('Error during WebSocket initialization:', error);
        }
    }
}
